var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantagesPrepaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2422 1.28597C12.9426 1.24322 12.6573 1.24322 12.3577 1.28597C12.0913 1.32397 11.8647 1.38171 11.4077 1.53099L5.4007 3.53283C4.70068 3.76617 4.22852 4.42126 4.22852 5.15914V13.1128C4.22852 17.3149 6.80623 20.5088 11.794 22.629C12.4368 22.9022 13.1631 22.9022 13.8059 22.629L14.1216 22.4919C18.9042 20.3705 21.3714 17.2223 21.3714 13.1128V5.15914C21.3714 4.42126 20.8992 3.76617 20.1992 3.53283L14.3534 1.58424C13.7851 1.39479 13.5382 1.3282 13.2422 1.28597ZM17.4348 8.99324C17.7438 9.30223 17.7675 9.78842 17.5061 10.1247L17.4348 10.2054L12.2919 15.3483C11.9829 15.6573 11.4967 15.681 11.1605 15.4196L11.0797 15.3483L8.29402 12.5626C7.95929 12.2278 7.95929 11.6851 8.29402 11.3504C8.60301 11.0414 9.0892 11.0176 9.42545 11.2791L9.5062 11.3504L11.6858 13.5293L16.2226 8.99324C16.5573 8.6585 17.1 8.6585 17.4348 8.99324Z",
    fill: "url(#paint0_linear_6310_99283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6310_99283",
    x1: 12.7999,
    y1: 1.25391,
    x2: 12.7999,
    y2: 22.8339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesPrepaid);
export default __webpack_public_path__ + "static/media/advantages_prepaid.cf3c71590cf67b9235562e55766340fe.svg";
export { ForwardRef as ReactComponent };